export enum EApiCallStateNames {
  DEMO = 'DEMO',
}

export enum EApiRequestPartKeys {
  SEARCH = 'SEARCH',
  PAGINATION = 'PAGINATION',
}
